import { computed, makeObservable } from 'mobx';
import { HtmlElementReactive } from 'src_common/common/mobx-utils/HtmlElementReactive';

export class HeroWidgetState {
    public readonly reactiveWrapper: HtmlElementReactive<HTMLElement> = new HtmlElementReactive(500);

    public constructor() {
        makeObservable(this);
    }

    @computed public get elementRefHeight(): number {
        const elementRef = this.reactiveWrapper.ref;

        return elementRef?.clientHeight ?? 0;
    }
}
